<template>
  <div>
    <b-card title="Create Stock Out">
      <div>
        <div class="d-flex justify-content-center mt-4 mb-2">
          <h2>Choose Items</h2>
        </div>

        <b-table-simple responsive class="no-scroll-table">
          <b-thead>
            <b-tr>
              <b-th>Item</b-th>
              <b-th>Batch No</b-th>
              <b-th>Exp Date</b-th>
              <b-th>Quantity</b-th>
              <b-th>Unit Price</b-th>
              <b-th>Actions</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, index) in stocks" :key="index">
              <b-td>
                <AutoComplete
                  class="mt-1"
                  style="width: 16rem"
                  placeholder="Select Item"
                  v-model="stocks[index].item"
                  @input="saveItem(stocks[index].item)"
                  param-query="search"
                  :serializer="(val) => val.id"
                  endpoint="item"
                  text-title="name"
              /></b-td>
              <b-td>
                <AutoComplete
                  class="mt-1"
                  v-if="stocks[index].item"
                  style="width: 16rem"
                  placeholder="Select Item"
                  v-model="stocks[index].batch_no"
                  @input="changeBalanceId(index)"
                  param-query="search"
                  :serializer="(val) => val.id"
                  endpoint="balance"
                  text-title="batch_no"
                  keyword="item"
                  :otherQuery="otherQuery"
                >
                  <template v-slot:option="option">
                    <div>
                      <b-badge variant="primary"
                        >Batch No: {{ option.batch_no }}
                      </b-badge>
                    </div>
                    <div>
                      <b-badge variant="danger">
                        Exp Date :{{ option.expiry_date }}
                      </b-badge>
                    </div>
                    <div>
                      <b-badge variant="warning">
                        Quantity :{{ option.quantity }}
                      </b-badge>
                    </div>
                  </template>
                </AutoComplete>
                <b-form-input
                  v-else
                  disabled
                  v-model="stocks[index].batch_no"
                ></b-form-input
              ></b-td>

              <b-td>
                <b-form-input
                  style="width: 8rem"
                  disabled
                  v-model="stocks[index].expiry_date"
                ></b-form-input>
              </b-td>
              <b-td>
                <b-form-input v-model="stocks[index].quantity"></b-form-input>
              </b-td>
              <b-td>
                <b-form-input v-model="stocks[index].unit_price"></b-form-input>
              </b-td>
              <b-td>
                <div class="d-flex align-items-end">
                  <b-button
                    class="mx-1"
                    variant="primary"
                    size="sm"
                    @click="addItem"
                    >+</b-button
                  >
                  <b-button
                    :disabled="index === 0"
                    size="sm"
                    variant="danger"
                    @click="removeItem(index)"
                    >X</b-button
                  >
                </div>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>

        <hr />
        <div class="d-flex justify-content-end">
          <b-button variant="primary" @click="submitItem">
            Dispense Stock
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BLink,
  BBadge,
  BTableSimple,
  BTbody,
  BThead,
  BTr,
  BTd,
  BTh,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import StatisticCardHorizontal from '@core/components/statistics-cards/StatisticCardHorizontal.vue';
const AutoComplete = () => import('@/components/common/AutoComplete.vue');
import Datepicker from 'vuejs-datepicker';

export default {
  components: {
    BTableSimple,
    BTbody,
    BThead,
    BTr,
    BTd,
    BTh,
    BCard,
    BBadge,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BLink,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    StatisticCardHorizontal,
    AutoComplete,
    Datepicker,
  },
  data() {
    return {
      take: 10,
      loading: true,
      itemId: '',
      balanceId: '',
      currentBalance: {},
      categoryId: null,
      stocks: [
        {
          item: '',
          quantity: '',
          batch_no: '',
          unit_price: 0,
          expiry_date: '',
          selectedBatch: '',
        },
      ],
      data: [],
      params: {
        form: {},
        path: '',
      },

      page: 1,
    };
  },

  computed: {
    // Update otherQuery based on itemId
    otherQuery() {
      if (this.itemId) {
        return `filter[item_id]=${this.itemId}&include=item,category,warehouse`;
      }
    },
  },

  methods: {
    saveItem(item) {
      this.itemId = item;
    },

    async changeBalanceId(index) {
      this.loading = true;
      let url = `/balance?page=${this.page}&take=${this.take}&sort=-id&filter[id]=${this.stocks[index].batch_no}&include=item,category,warehouse`;

      await this.getList(url);
      this.currentBalance = this.all_data.data[0];
      this.stocks[index].quantity = this.currentBalance.quantity;
      this.stocks[index].expiry_date = this.currentBalance.expiry_date;
      this.stocks[index].unit_price = this.currentBalance.unit_price;
      this.loading = false;
    },
    addItem() {
      this.stocks.push({
        quantity: '',
        batch_no: '',
        unit_price: 0,
        expiry_date: '',
      });
    },
    removeItem(index) {
      if (index === 0) return;
      this.stocks.splice(index, 1);
    },

    submitItem() {
      this.stocks = this.stocks.map((stock) => ({
        quantity: stock.quantity,
        price: stock.unit_price,
        balance_id: stock.batch_no,
      }));

      (this.params.form = { stockouts: this.stocks }),
        (this.params.path = `/stockout`),
        this.$store
          .dispatch('create', this.params)
          .then((response) => {
            this.$router.push({ name: 'stockout' });

            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Created',
                variant: 'success',
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'validation error',
                    variant: 'danger',
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>
<style scoped>
.table-container {
  min-height: 100vh !important; /* Adjust based on your needs */
  overflow: visible; /* Ensure the container doesn't scroll */
}
.b-table,
.table-container {
  overflow: visible !important; /* Force the table and container not to scroll */
}
.no-scroll-table {
  overflow: visible !important; /* Prevent scrolling within the table */
}
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, 'Segoe UI', Roboto, Oxygen,
    Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
